export type PublicSketchupEstimateDisclosure = {
  headline: string;
  showTotal: boolean;
  note: string;
};

type GroupSummary = { count?: number; complete?: boolean; rows?: unknown[] } | undefined | null;

export function publicSketchupEstimateDisclosure(
  status: string | null | undefined,
  unpricedSourceGroups: GroupSummary,
  sourceDefaultedGroups: GroupSummary,
): PublicSketchupEstimateDisclosure {
  const unpricedCount = Number(unpricedSourceGroups?.count ?? 0);
  const sourceComplete = unpricedSourceGroups?.complete === true && unpricedCount === 0;
  if (status === 'NATIVE_QUOTE_PARTIAL' && unpricedCount > 0) {
    // 28.09.2026 — фаза 4 (правка BLOCK-ревью): «перечислены ниже» честно
    // только когда экспорт принёс строки. Легаси-экспорты без rows и
    // предварительные ссылки обещают отдельное сообщение вместо списка.
    const hasRows = Array.isArray(unpricedSourceGroups?.rows) && (unpricedSourceGroups?.rows?.length ?? 0) > 0;
    return { headline: 'Полный итог не определён', showTotal: false,
      note: hasRows
        ? `Штатная смета. ${unpricedCount} позиций пока без цены; они перечислены ниже. Полная стоимость заказа ещё не определена.`
        : `Штатная смета. ${unpricedCount} позиций пока без цены; их стоимость мы сообщим отдельно до подписания. Полная стоимость заказа ещё не определена.` };
  }
  if (status === 'NATIVE_QUOTE_COMPLETE' && sourceComplete) {
    return { headline: 'Смета · сохранённая версия КП', showTotal: true,
      note: 'Цены зафиксированы в этой версии коммерческого предложения.' };
  }
  if (!sourceComplete) {
    return {
      headline: 'Требует уточнения',
      showTotal: false,
      note: `Не назначены клиентские ставки: ${unpricedCount || 'есть'}. Итог не является ценой для клиента.`,
    };
  }

  const defaultedCount = Number(sourceDefaultedGroups?.count ?? 0);
  if (defaultedCount > 0 || status === 'PRELIMINARY_COMPLETE_WITH_DEFAULTS') {
    return {
      headline: 'Предварительный расчёт',
      showTotal: true,
      note: defaultedCount > 0
        ? `Использованы утверждённые дефолты для ${defaultedCount} групп; нужна проверка перед заказом.`
        : 'Расчёт построен по утверждённым дефолтам; нужна проверка перед заказом.',
    };
  }

  return { headline: 'Расчёт', showTotal: true, note: '' };
}
